// ⚠️ AUTO-GENERATED FROM CORE REPO
// DO NOT EDIT — changes will be overwritten

/* Native option groups backed exclusively by this product's Shopify variants. */
if (!customElements.get('core-native-product-options')) {
  customElements.define('core-native-product-options', class extends HTMLElement {
    initialize(variants, select) {
      if (this.initialized) return;
      this.initialized = true;
      const groups = [...this.querySelectorAll('fieldset')];
      const resolve = () => {
        const values = [];
        groups.forEach((group, position) => {
          const inputs = [...group.querySelectorAll('input')];
          inputs.forEach(input => {
            // Availability depends only on earlier choices, never later ones.
            input.disabled = !variants.some(variant => variant.available &&
              variant.options[position] === input.value &&
              values.every((value, index) => variant.options[index] === value));
          });
          // Keep a valid selection; otherwise take the first available displayed option.
          const choice = inputs.find(input => input.checked && !input.disabled) ||
            inputs.find(input => !input.disabled);
          if (choice) inputs.forEach(input => { input.checked = input === choice; });
          values.push(choice?.value);
        });
        const variant = variants.find(item => item.available &&
          item.options.every((value, index) => value === values[index]));
        // With no stock, retain Shopify's sold-out variant and disabled cart state.
        if (!variant || select.value === String(variant.id)) return;
        select.value = String(variant.id);
        select.dispatchEvent(new Event('change', { bubbles: true }));
      };
      this.addEventListener('change', event => {
        if (event.target.matches('input[type="radio"]')) resolve();
      });
      resolve();
    }
  });
}
